// The two `/user-activity/*evidence` READ transports — BORN here rather than
// moved, because they had no api module: each was an inline `queryFn` body
// inside its own hook file, reachable only through a mocked `useQuery` options
// object. That is the same shape `data/api/sources.ts` was born from at the
// sibling carve, and the same reason applies — "same route, same verb, same
// `.data` unwrapping" was a claim nobody could check, so splitting the transport
// out is what makes the S1 severance testable at all.
//
// A SEPARATE MODULE FROM `evidence-leaderboard.ts`, deliberately. That module is
// `/competitions/*` + `/evidence-referrals/*`; these two are `/user-activity/*`,
// a third route family with a different owner on the backend. Folding them in
// would make the module's name a lie and would hide the one thing a reader
// should notice about them — that they are claimed by cache identity rather than
// by route (see `useQueryEvidenceUsageStats.ts`).
//
// S1: `@/utils/scribeHTTP#scribeHttpV2` becomes
// `getScribeHttpClients().scribeHttpV2`, the SAME instance, resolved per call.
import { getScribeHttpClients } from '@heidi/api/client';

import type { EvidenceUsageStatsResponse } from '../../contracts';

interface ScribeHttp {
  get<T>(url: string): Promise<{ data: T }>;
}

// `scribeHttpV2` base is /api/v2/ml-scribe/; scribe JWT injected by interceptor.
const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;

/** `GET /user-activity/evidence` — the signed-in clinician's own usage. */
export async function getEvidenceUsageStats(): Promise<EvidenceUsageStatsResponse> {
  const { data } = await http().get<EvidenceUsageStatsResponse>(
    '/user-activity/evidence'
  );
  return data;
}

/**
 * `GET /user-activity/team/{team_id}/evidence` — the same aggregate summed
 * across a team.
 *
 * The endpoint returns 403 for non-admin callers, so consumers gate the call
 * upstream rather than this module swallowing the failure.
 */
export async function getTeamEvidenceUsageStats(
  teamId: string
): Promise<EvidenceUsageStatsResponse> {
  const { data } = await http().get<EvidenceUsageStatsResponse>(
    `/user-activity/team/${teamId}/evidence`
  );
  return data;
}
